// React
import React from 'react'

// Third Party
import moment from 'moment'
import ReactMarkdown from 'react-markdown'

/**
 * @typedef {{
 *  date: unknown
 *  title: string
 *  text: string
 * }} BlogProps
 */

/**
 * @param {BlogProps} BlogProps
 */
export default function Blog({ date, text, title }) {
  return (
    <div className='blog__item'>
      <a href={this.props.link} className='blog__tile'>
        <p className='blog__date'>{moment(date).format('ll')}</p>
        <div className='heading--small bold heading--green'>{title}</div>
        <div className='paragraph--sans blog__container__text'>
          <ReactMarkdown escapeHtml={false} source={text} />
        </div>

        <i className='icon-arrow-circle' />
      </a>
    </div>
  )
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/Blog.jsx